// extracted by mini-css-extract-plugin
module.exports = {"container":"_3jaG4w_r4vNlnWkfXc_234"};